import { Controller } from "react-hook-form";
import { Stack, Group } from "@mantine/core";
import { RadioButton } from "@onengine/component-library";
import { FormErrorBox } from "@/components/ui/FormErrorBox/FormErrorBox";
import { OtherTextInput } from "./OtherTextInput";
import type { ControlledFieldProps } from "./types";

const OTHER_VALUE = "__other__";

export function ControlledRadio({
  name,
  control,
  error,
  clearErrors,
  options,
  allowOther,
}: ControlledFieldProps & { options: { label: string; value: string }[]; allowOther?: boolean }) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => {
        const isOtherSelected = field.value === OTHER_VALUE;
        return (
          <Stack gap="xs">
            <RadioButton
              options={allowOther ? options.filter((o) => o.label !== "Other") : options}
              selectedValue={isOtherSelected ? "" : field.value || ""}
              onValuesChange={(val) => {
                field.onChange(val);
                clearErrors(name);
              }}
              size="small"
            />
            {error && <FormErrorBox message={error} />}
            {allowOther && (
              <Group gap="sm" align="flex-start" wrap="nowrap">
                <RadioButton
                  label="Other"
                  size="small"
                  state={isOtherSelected ? "selected" : "deselected"}
                  onValueChange={() => {
                    field.onChange(OTHER_VALUE);
                    clearErrors(name);
                  }}
                />
                <OtherTextInput
                  name={`${name}__other`}
                  control={control}
                  disabled={!isOtherSelected}
                />
              </Group>
            )}
          </Stack>
        );
      }}
    />
  );
}
